<section class="section-div">
  <div class="content-details">
    <div class="title-details">
      <div class="d-flex">
        <h4><ion-icon name="images-outline"></ion-icon> Gallery List</h4>
        <div class="ml-auto">
          <button
            mat-raised-button
            color="primary"
            (click)="eventAddBtn('Add')"
          >
            Add Gallery
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="noData == false">
      <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="dataSource" [class.isMobile]="isMobile">
          <ng-container matColumnDef="index">
            <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index">
              <span class="mobile-label">No :</span>
              {{ paginator.pageSize * paginator.pageIndex + i + 1 }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="galleryTags">
            <mat-header-cell *matHeaderCellDef> Gallery Tag</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label"> Gallery Tag:</span>
              {{ element.galleryTags }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span class="mobile-label">Action:</span>
              <mat-icon
                class="edit-i"
                (click)="editGallery('Update', element.id)"
              >
                edit</mat-icon
              >
              <mat-icon class="delete-i" (click)="deleteGallery(element.id)">
                delete</mat-icon
              >
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
      <mat-paginator
        [ngClass]="{ 'd-none': roleValue == 'Incubator' }"
        #paginator
        class="mat-elevation-z8"
        [length]="pageTotalCount"
        [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 75, 100]"
        showFirstLastButtons
        (page)="getServerData($event)"
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
    <div class="text-center no-data-div" *ngIf="noData == true">
      <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
      <h6>No Records Found</h6>
    </div>
  </div>
</section>
